export { Authorization } from '@pages/Authorization/ui/Authorization';
export { adaptUserToRedux } from '@pages/Authorization/utils/adaptUserToRedux';
